import { z } from 'zod';

/**
 * Csomagon-TÚLI kurált tartozék-katalógus szerződés (E-105 Phase 3, BE-1 — opció 2).
 *
 * A `GET /rental-equipment/:id/accessory-catalog` az adott bérgép gép-modelljéhez
 * KURÁLT, csomag-független tartozékokat adja vissza (rentable/consignment/free), hogy
 * a wizard step-2 detail-editor a `useAccessoriesForEquipment(equipmentId)` hookkal
 * 1:1 renderelje a kategória-tabokat + a per-accessory sorokat.
 *
 * Forrás (BE): RentalAccessoryCatalogEntry (gép-Product ↔ tartozék-Product kurált link) →
 * accessory-Product (category/image/sellingPrice/minStockLevel). A `kind` a kurált entry
 * PackageItemCategory-je (ADR-118 Am.2), uppercase — a FE 0-mapping (NEM v3 lowercase).
 */

// A tartozék elszámolási típusa = a BE PackageItemCategory enum (uppercase, FE 0-mapping).
export const RentalAccessoryKindSchema = z.enum(['FREE', 'RENTABLE', 'CONSIGNMENT']);
export type RentalAccessoryKind = z.infer<typeof RentalAccessoryKindSchema>;

// Egy katalógus-tétel (accessory-Product az adott géphez kurálva).
export const RentalAccessoryCatalogItemSchema = z.object({
  id: z.string().uuid(), // accessory-Product id (cart-relevant)
  equipmentId: z.string().uuid(),
  name: z.string().min(1),
  sku: z.string(),
  cat: z.string(), // kategória-tab kulcs (ProductCategory.name)
  kind: RentalAccessoryKindSchema,
  dailyRate: z.number().nonnegative(), // RENTABLE → lineTotal = dailyRate*qty*days
  price: z.number().nonnegative().nullable(), // CONSIGNMENT egységár
  stock: z.number().int().nonnegative(), // "n db raktáron" (v1: min_stock_level)
  imageUrl: z.string().nullable(), // relatív v. abszolút URL is lehet → NEM .url()
});
export type RentalAccessoryCatalogItem = z.infer<typeof RentalAccessoryCatalogItemSchema>;

// A teljes válasz: { data, meta } — meta.categories → tab-fejlécek előgenerálva.
export const RentalAccessoryCatalogResponseSchema = z.object({
  data: z.array(RentalAccessoryCatalogItemSchema),
  meta: z.object({
    equipmentId: z.string().uuid(),
    total: z.number().int().nonnegative(),
    categories: z.array(z.string()),
  }),
});
export type RentalAccessoryCatalogResponse = z.infer<typeof RentalAccessoryCatalogResponseSchema>;
